"use client";

import * as React from "react";
import styled from "styled-components";

const StyledCard = styled.div`
  border-radius: 12px;
  border: 1px solid var(--color-border-default);
  background-color: var(--color-bg-surface);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
`;

const StyledCardHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 24px;
`;

const StyledCardTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  line-height: 1.2;
  letter-spacing: -0.01em;
  margin: 0;
  color: var(--color-text-primary);
`;

const StyledCardDescription = styled.p`
  font-size: 14px;
  color: var(--color-text-secondary);
  margin: 0;
`;

const StyledCardContent = styled.div`
  padding: 0 24px 24px;
`;

const StyledCardFooter = styled.div`
  display: flex;
  align-items: center;
  padding: 0 24px 24px;
  gap: 12px;
`;

const Card = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  (props, ref) => <StyledCard ref={ref} {...props} />
);
Card.displayName = "Card";

const CardHeader = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  (props, ref) => <StyledCardHeader ref={ref} {...props} />
);
CardHeader.displayName = "CardHeader";

const CardTitle = React.forwardRef<HTMLParagraphElement, React.HTMLAttributes<HTMLHeadingElement>>(
  (props, ref) => <StyledCardTitle ref={ref} {...props} />
);
CardTitle.displayName = "CardTitle";

const CardDescription = React.forwardRef<HTMLParagraphElement, React.HTMLAttributes<HTMLParagraphElement>>(
  (props, ref) => <StyledCardDescription ref={ref} {...props} />
);
CardDescription.displayName = "CardDescription";

const CardContent = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  (props, ref) => <StyledCardContent ref={ref} {...props} />
);
CardContent.displayName = "CardContent";

const CardFooter = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  (props, ref) => <StyledCardFooter ref={ref} {...props} />
);
CardFooter.displayName = "CardFooter";

export { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent };
